/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { deepObjectExtend } from '../utils/object';
import { rowSpacing, fontSize } from './variables';

export const combineStyle = (typography, palette, classObjFunc) => {
    let styles = {};

    if (typeof classObjFunc === 'object') {
        Object.keys(classObjFunc).forEach((item) => {
            const classFunc = classObjFunc[item];
            if (typeof classFunc === 'function') {
                const classObj = classFunc(typography, palette);
                Object.keys(classObj).forEach((className) => {
                    if (typeof classObj === 'object') {
                        styles = deepObjectExtend(styles, {
                            [className]: { ...classObj[className] },
                        });
                    }
                });
            }
        });
    }

    return {
        ...styles,
    };
};

export { rowSpacing, fontSize };

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    combineStyle,
    rowSpacing,
    fontSize,
};
